import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { Colors } from "../../../helpers/Colors";
import MyReservations from "..";
import { format } from "date-fns";
import { FcCancel } from "react-icons/fc";
import { AiOutlineEdit } from "react-icons/ai";
import { fontSize } from "../../../helpers/fontSize";
import Edit_Model from "./modals/Edit_Model";
import { IoClose } from "react-icons/io5";
import Delete_Model from "./modals/Delete_Model";
import { Modal_useStyles } from "../../../useStyles/Modal_useStyles";
import Card_myReservations from "../../../components/Card_myReservations";

const useStyles = makeStyles({
  Page: {
    "& th": {
      zIndex: 0,
    },
    // "& .MuiTableHead-root .css-15wwp11-MuiTableHead-root": {
    //   zIndex: 0,
    // },
    // "& tr": {
    //   zIndex: 0,
    // },
  },
  TableHead: {
    //  padding: "20px",
    //  "& .TableRow": {
    //  },
  },
  TableRow: {
    "& .columns": {
      fontWeight: 600,
      backgroundColor: Colors.primaryMedium,
      // "& th": {
      //   zIndex: -1,
      // },
      // color: Colors.jerry,
    },
    "& #bookingID": {
      minWidth: 50,
    },
  },
  TableData_Row: {
    "&:nth-of-type(even)": {
      backgroundColor: Colors.primaryExtraLight,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
    "& .actions": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& div": {
        width: "20px",
        height: "20px",
        fontSize: "22px",
        cursor: "pointer",
        position: "relative",
        "&:hover .edit": { display: "block" },
        "& .edit": {
          display: "none",
          backgroundColor: Colors.error,
          position: "absolute",
          top: 0,
          right: 20,
          zIndex: 0,
          padding: "1px 3px",
          fontSize: fontSize.label,
          backgroundColor: Colors.white,
          border: `1px solid ${Colors.secondary}`,
        },
        "&:hover .cancel": { display: "block" },
        "& .cancel": {
          display: "none",
          backgroundColor: Colors.error,
          position: "absolute",
          top: 0,
          left: 22,
          zIndex: 0,
          padding: "1px 3px",
          fontSize: fontSize.label,
          backgroundColor: Colors.white,
          border: `1px solid ${Colors.secondary}`,
        },
      },
      "& #edit": {
        margin: "0 12px 0 0",
      },
    },
  },
  Modal_Background: {
    zIndex: 1,
    backgroundColor: Colors.secondaryBgOpacity,
    position: "absolute",
    margin: "auto",
    width: "full",
    height: "100%",
    // opacity: 0.6,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  Update_Import_Modal: {
    zIndex: 2,
    overflow: "hidden",
    position: "absolute",
    margin: "auto",
    // opacity: 1,
    width: "fit-content",
    height: "fit-content",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: Colors.white,
    padding: "20px",
    borderRadius: "10px",
    boxShadow: `0px 3px 10px ${Colors.primary}`,
    // box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    "@media only screen and (max-Width: 1165px) ": {
      width: "fit-content",
      height: "fit-content",
    },
    "@media only screen and (max-Width: 430px) ": {
      width: "70%",
      height: "70%",
    },
    "& .Import_Modal_Container": {
      width: "100%",
      height: "100%",
      position: "relative",
      "& .closeIconCon_Relative": {
        "& .closeIcon_Relative": {
          cursor: "pointer",
          position: "sticky",
          zIndex: 3,
          position: "absolute",
          border: `3px solid ${Colors.primary}`,
          color: Colors.primary,
          fontSize: "25px",
          borderRadius: "20px",
          top: -6,
          right: -5,
          "@media only screen and (max-Width: 430px) ": {
            fontSize: "20px",
          },
        },
      },
      "& .update": {
        padding: "0px 0px 15px 0px",
        fontSize: fontSize.update_delete,
        fontWeight: 600,
      },
      "& .delete": {
        display: "flex",
        flexDirection: "column",
        "& .deleteName": {
          padding: "0px 0px 15px 0px",
          fontSize: fontSize.update_delete,
          fontWeight: 600,
        },
        "& label": {
          width: "400px",
          fontWeight: 450,
          fontSize: fontSize.paragraph,
          padding: "0px 0px 15px 0px",
          "@media only screen and (max-Width: 770px) ": {
            width: "300px",
            fontSize: fontSize.Tablet_paragraph,
            padding: "0px 0px 10px 0px",
          },
          "& .content": {
            color: Colors.black,
            fontWeight: 600,
          },
        },
      },
      "& .Submit_Con": {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "0px 0px 0px 0",
        margin: "10px 0px 0px 0px",
        "@media only screen and (max-Width: 770px) ": {
          display: "flex",
          flexDirection: "column",
        },
        "& label": {
          fontSize: "18px",
          color: Colors.labelText,
        },
        "& button": {
          padding: "10px 10px",
          margin: "2px 0px 0 0 ",
          outline: "none",
          border: `2px solid ${Colors.inputBg}`,
          backgroundColor: Colors.primary,
          fontSize: "16px",
          borderRadius: "5px",
          color: Colors.sidebarWhite,
          "@media only screen and (max-Width: 770px) ": {},
        },
        "& ::placeholder": {},
      },
    },
  },
});

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//   },
// }));

const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const columns = [
  {
    id: "sno",
    label: "S. No.",
    minWidth: 30,
    align: "center",
  },
  {
    id: "bookingID",
    label: "Booking ID",
    minWidth: 120,
    align: "center",
  },
  {
    id: "cabinName",
    label: "Cabin Name",
    minWidth: 100,
    align: "center",
  },
  {
    id: "day",
    label: "Day",
    minWidth: 100,
    align: "center",
  },
  {
    id: "startTime",
    label: "Start Time",
    minWidth: 100,
    align: "center",
  },
  {
    id: "endTime",
    label: "End Time",
    minWidth: 100,
    align: "center",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "center",
  },
];

const Table_myReservations = ({
  myReservations,
  showEditModal,
  setShowEditModal,
  showCancelModal,
  setShowCancelModal,
  triggerUseEffect,
  setUseEffect,
}) => {
  const classes = useStyles();
  const Modal_Classes = Modal_useStyles();
  // const [filteredData, setFilteredData] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [selectedID, setSelectedID] = useState(null);
  const [enteredDeleteContent, setEnteredDeleteContent] = useState("");

  const onEditClick = (row) => {
    setShowEditModal(true);
    setSelectedID(row);
    setUseEffect(true);
    // console.log(row);
  };
  const onCancelClick = (row) => {
    setShowCancelModal(true);
    setSelectedID(row);
    setUseEffect(true);
    // console.log(row);
  };
  const onCloseClick = () => {
    setShowEditModal(false);
    setShowCancelModal(false);
    setUseEffect(true);
  };

  // console.log(myReservations);
  return (
    <main className={classes.Page}>
      <Paper
        sx={{ width: "100%", overflow: "auto" }}
        className="hidden 900px:block"
      >
        <TableContainer sx={{ maxHeight: 430 }}>
          <Table stickyHeader aria-label="sticky table">
            {/* <Table striped> */}
            <TableHead>
              <TableRow className={classes.TableRow}>
                {columns.map((column) => (
                  <TableCell
                    className="columns"
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {myReservations
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow
                    key={row._id}
                    className={classes.TableData_Row}
                  >
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell component="th" align="center" scope="row">
                      {row._id}
                    </TableCell>
                    <TableCell align="center">
                      {row.cabinName.cabinName}
                    </TableCell>
                    <TableCell align="center">
                      {format(new Date(row.day), "dd/MM/yyyy")}
                    </TableCell>
                    <TableCell align="center">
                      {format(new Date(row.startTime), "hh:mm a")}
                    </TableCell>
                    <TableCell align="center">
                      {format(new Date(row.endTime), "hh:mm a")}
                    </TableCell>
                    <TableCell align="center" className="actions">
                      <div
                        id="edit"
                        className=""
                        onClick={() => onEditClick(row)}
                      >
                        <AiOutlineEdit className="editIcon" />
                        <p className="edit">Edit</p>
                      </div>
                      <div onClick={() => onCancelClick(row)}>
                        <FcCancel />
                        <p className="cancel">cancel</p>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={myReservations.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <Card_myReservations
        myReservations={myReservations}
        onEditClick={onEditClick}
        onCancelClick={onCancelClick}
      />

      {showEditModal ? (
        <main className={Modal_Classes.Modal_Background}>
          <main className={Modal_Classes.Update_Import_Modal}>
            <section className={"Import_Modal_Container"}>
              <div className="update">Update a Reservation</div>
              <div className="closeIconCon_Relative" onClick={onCloseClick}>
                <IoClose className="closeIcon_Relative" />
              </div>
              <main className={classes.Input_Container}>
                <Edit_Model
                  showEditModal={showEditModal}
                  setShowEditModal={setShowEditModal}
                  selectedID={selectedID}
                  setSelectedID={setSelectedID}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              </main>
            </section>
          </main>
        </main>
      ) : null}
      {showCancelModal ? (
        <main className={Modal_Classes.Modal_Background}>
          <main className={Modal_Classes.Update_Import_Modal}>
            <section className={"Import_Modal_Container"}>
              <div className="update">Cancel a Reservation</div>
              <div className="closeIconCon_Relative" onClick={onCloseClick}>
                <IoClose className="closeIcon_Relative" />
              </div>
              <main className={classes.Input_Container}>
                <Delete_Model
                  name={"Reservation"}
                  showCancelModal={showCancelModal}
                  setShowCancelModal={setShowCancelModal}
                  selectedID={selectedID}
                  setSelectedID={setSelectedID}
                  enteredDeleteContent={enteredDeleteContent}
                  setEnteredDeleteContent={setEnteredDeleteContent}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              </main>
            </section>
          </main>
        </main>
      ) : null}
    </main>
  );
};

export default Table_myReservations;
